
export async function getEthereumProviderAsync() {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
  const maxAttempts = isMobile ? 50 : 25  // ~15s mobile, ~7.5s desktop
  const getProv = () => window.bybitWallet || window.ethereum

  const hasApi = (prov) =>
    !!prov && (typeof prov.request === 'function' || typeof prov.send === 'function' || typeof prov.enable === 'function')

  for (let i = 0; i < maxAttempts; i++) {
    const prov = getProv()
    if (hasApi(prov)) return prov
    await new Promise((r) => setTimeout(r, 300))
  }
  const prov = getProv()
  return hasApi(prov) ? prov : null
}
